import React, { useMemo } from 'react';

// helpers
import useTranslation from 'hooks/useTranslation';
import { SourceOfFundingOptions } from 'enums/onboarding/crm';
import { SelectOption, FormSelectProps } from '@ui';

// components
import { FormSelect } from '@ui';

export type IProps = FormSelectProps;

const SourceOfFundingSelect = (props: IProps) => {
  const { t } = useTranslation('onboarding');

  const options = useMemo<SelectOption[]>(
    () =>
      Object.values(SourceOfFundingOptions).map((key) => ({
        id: key,
        label: t(`intake_form.source_of_funding_options.${key}`),
      })),
    [t],
  );

  return <FormSelect {...props} options={options} />;
};

export default SourceOfFundingSelect;
